module.exports = __webpack_public_path__ + "img/delay-up.f64ba3f.svg";